import React, { useState } from "react";
import PropTypes from "prop-types";
import { ConfirmModal } from "../../../../boxes/ConfirmModal/ConfirmModal";
import { uiNotification } from "../../../../services/UINotificationService";

/*
 * Shown after a text2pay booking. The slot is held but the appointment is not
 * confirmed until the link is paid, so this states what happens next and always
 * offers the link — the text can fail while the booking itself succeeds.
 */
const AppointmentPendingPaymentModal = ({
  isOpen,
  onClose,
  paymentLink,
  isLinkSent,
  expiresInMinutes,
}) => {
  const [isCopied, setIsCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(paymentLink);
      setIsCopied(true);
    } catch (e) {
      uiNotification.error("Could not copy the payment link");
    }
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      /* Done is the primary action; ConfirmModal renders onConfirm first, so it sits left */
      onConfirm={onClose}
      onCancel={paymentLink ? onCopy : undefined}
      confirmTitle="Done"
      cancelTitle={isCopied ? "Copied" : "Copy payment link"}
      title="Appointment held — not yet confirmed"
    >
      <div>
        {isLinkSent
          ? "We texted the patient a payment link. The appointment confirms automatically once the payment goes through."
          : "We could not text the patient the payment link. Share it with them — the appointment confirms automatically once the payment goes through."}
      </div>
      {expiresInMinutes && (
        <div className="m-t-10">
          {`The slot is held for ${expiresInMinutes} minutes, after that it opens back up.`}
        </div>
      )}
      {!paymentLink && (
        <div className="m-t-10">
          No payment link could be generated. Please rebook the appointment.
        </div>
      )}
    </ConfirmModal>
  );
};

AppointmentPendingPaymentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  paymentLink: PropTypes.string,
  isLinkSent: PropTypes.bool,
  expiresInMinutes: PropTypes.number,
};

AppointmentPendingPaymentModal.defaultProps = {
  paymentLink: "",
  isLinkSent: false,
  expiresInMinutes: null,
};

export default AppointmentPendingPaymentModal;
